export default {"src":"/_next/static/media/close-black-light.a4cc30f7.svg","height":24,"width":24};